import { render, staticRenderFns } from "./TableColumns.vue?vue&type=template&id=4eb0fcb9&"
import script from "./TableColumns.vue?vue&type=script&lang=js&"
export * from "./TableColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports